import React from 'react';
import SectionEContextQuestion from './SectionEContextQuestion';
import {Box, Button, Checkbox, CircularProgress, FormControlLabel, Stack, TextField, Typography} from '@mui/material';
import { SavedWorkActionRow } from './SavedWorkActionRow';
/** OT-local external labels deliberately avoid the global floating-label theme. */
export function OtField({ id, label, value, onChange, disabled, multiline = true, select = false, children, helper, required, onBlur, type = 'text' }: {
    id: string;
    label: string;
    value: any;
    onChange: (value: string) => void;
    disabled?: boolean;
    multiline?: boolean;
    select?: boolean;
    children?: React.ReactNode;
    helper?: string;
    required?: boolean;
    type?: string;
    onBlur?: () => void;
}) {
    return <Box sx={{ minWidth: 0, width: '100%' }}>
    <Typography component="label" id={`${id}-label`} htmlFor={id} variant="body2" sx={{ display: 'block', mb: 0.75, fontWeight: 600 }}>{label}</Typography>
    <TextField id={id} onBlur={onBlur} fullWidth variant="outlined" value={value ?? ''} onChange={event => onChange(event.target.value)} disabled={disabled} multiline={multiline && !select} minRows={multiline && !select ? 2 : undefined} select={select} SelectProps={select ? { labelId: `${id}-label` } : undefined} type={type} inputProps={{ 'aria-required': required, ...(helper ? { 'aria-describedby': `${id}-help` } : {}) }}>{children}</TextField>{helper && <Typography id={`${id}-help`} variant="caption" color="text.secondary">{helper}</Typography>}</Box>;
}
/** Single agent entry point for each stage, including fresh reruns and retries. */
export function OtAgentAction({ busy, disabled, useSavedWork, onUseSavedWork, onRun, label, leading }: {
    busy: boolean;
    disabled: boolean;
    useSavedWork: boolean;
    onUseSavedWork: (checked: boolean) => void;
    onRun: () => void;
    label: string;
    leading?: React.ReactNode;
}) {
    return <Stack alignItems="center" spacing={0} sx={{ width: '100%', mt: 1, '& .MuiFormControlLabel-root': { m: 0, minHeight: 44 } }} data-testid="ot-agent-action">
    <SavedWorkActionRow
      leading={leading}
      stackLeadingOnMobile
      action={<Button variant="contained" disabled={busy || disabled} onClick={onRun} aria-busy={busy} startIcon={busy ? <CircularProgress size={18} color="inherit" aria-label={`Generating ${label.replace(/^Generate |^Regenerate /, '')}`}/> : undefined}>{label}</Button>}
      savedWork={<FormControlLabel sx={{ m: 0 }} control={<Checkbox checked={useSavedWork} disabled={busy || disabled} onChange={event => onUseSavedWork(event.target.checked)}/>} label="Use Saved Work"/>}
    />
    </Stack>;
}

/** Free-form user answers use the same question/answer layout as Market Research C–E. */
export function OtQuestion({id, label, value, onChange, disabled, helper, required, rationale}: {
    id:string;label:string;value:any;onChange:(value:string)=>void;disabled?:boolean;helper?:string;required?:boolean;rationale?:string;
}) {
    return <SectionEContextQuestion id={id} question={label} rationale={rationale} guidance={helper} value={value ?? ''} onChange={onChange} disabled={disabled} required={required}/>;
}
